import { render, staticRenderFns } from "./OperacionResumenCorteDetalle.vue?vue&type=template&id=397c8fac&scoped=true&"
import script from "./OperacionResumenCorteDetalle.vue?vue&type=script&lang=js&"
export * from "./OperacionResumenCorteDetalle.vue?vue&type=script&lang=js&"
import style0 from "./OperacionResumenCorteDetalle.vue?vue&type=style&index=0&id=397c8fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c8fac",
  null
  
)

export default component.exports